import { unitType } from '../util/unitType';

export const generateCheckboxConfig = ({ units, site, prodUnit, isNorco, isNorcoWest, isRhienland, isSyngas, isBonga, isScotfordHCU, isBukom, isNorcoEast }) => {
    const MeasuredWallThicknessMetric = "MeasuredWallThickness";
    // const PredictedWallThicknessMetric = "LiveModelWallThickness";
    // const TemperatureMetric = isNorco ? "HCU_Temperature_F" : "Temperature";
    // const PressureMetric = isNorco ? "HCU_H2_Partial_Pressure_PSIG" : "Pressure";

    return {
        MeasuredWallThickness: {
            available: true,
            fetch: 1,
            group: 1,
            enabled: true,
            name: "Measured wall thickness",
            unit: "(" + unitType(units, 'length', "ui") + ")",
            expr_unit: unitType(units, 'length'),
            expr: MeasuredWallThicknessMetric,
            color: "#0097A9",
            variablemarkers: true
        },
        MeasuredCorrosionRate: {
            available: true,
            fetch: 1,
            group: 1,
            enabled: false,
            name: "Measured corrosion rate",
            unit: "(" + unitType(units, 'velocity mils', "ui") + ")",
            expr_unit: unitType(units, 'velocity mils'),
            expr: "MeasuredCorrosionRate",
            color: "#336094"
        },
        MinimumAllowableWallThickness: {
            available: true,
            fetch: 1,
            group: 1,
            enabled: false,
            name: "Minimum Required wall thickness",
            unit: "(" + unitType(units, 'length', "ui") + ")",
            expr_unit: unitType(units, 'length'),
            expr: "MinimumWallThickness",
            color: "#854785"
        },
        NominalWallThickness: {
            available: !isRhienland && !isNorcoEast && !isBukom,
            fetch: 1,
            group: 1,
            enabled: false,
            name: " Nominal WT",
            unit: "(" + unitType(units, "length", "ui") + ")",
            expr_unit: unitType(units, 'length'),
            expr: "NominalWallThickness",
            color: "#8fb753",
            width: "1",
        },
        Density: {
            available: !isNorco && !isBonga && !isScotfordHCU,
            fetch: 1,
            group: 1,
            enabled: false,
            name: "Density",
            unit: "(" + unitType(units, 'density', "ui") + ")",
            expr_unit: units ? "lb_per_gal" : null,
            expr: "Density",
            color: "#ff887b"
        },
        Viscosity: {
            available: !isNorco && !isSyngas && !isBonga,
            fetch: 1,
            group: 1,
            enabled: false,
            name: "Viscosity",
            unit: "(" + unitType(units, 'viscosity', "ui") + ")",
            expr_unit: units ? "sqft_per_s" : null,
            expr: "Viscosity",
            color: "#ffdaae"
        },
        Temperature: {
            available: true,
            fetch: 1,
            group: 2,
            enabled: false,
            name: "Temperature",
            unit: "(" + unitType(units, 'temperature', "ui") + ")",
            expr_unit: unitType(units, 'temperature'),
            expr: "Temperature",
            color: "#dd1d21",
            yaxis: "y2"
        },
        Pressure: {
            available: true,
            fetch: 1,
            group: 2,
            enabled: false,
            name: "Pressure",
            unit: "(" + unitType(units, 'pressure', "ui") + ")",
            expr_unit: unitType(units, 'pressure'),
            expr: "Pressure",
            color: "#C39EC9",
            yaxis: "y2"
        },
        PredictedWallThickness: {
            available: true,
            fetch: 1,
            group: 3,
            enabled: true,
            name: "Predicted wall thickness",
            unit: "(" + unitType(units, 'length', "ui") + ")",
            expr_unit: unitType(units, 'length'),
            expr: "LiveModelWallThickness",
            variablemarkers: true,
            color: "#000000"
        },
        PredictedCorrosionRate: {
            available: true,
            fetch: 1,
            group: 3,
            enabled: false,
            name: "Predicted corrosion rate",
            unit: "(" + unitType(units, 'velocity mils', "ui") + ")",
            expr_unit: unitType(units, 'velocity mils'),
            expr: "LiveModelCorrosionRate",
            color: "#FFDF55"
        },
        PredictedCorrosionRateConfidenceBandLowerValue: {
            available: true,
            fetch: 1,
            group: 3,
            enabled: false,
            name: "Predicted corrosion rate confidence band lower value",
            unit: "(" + unitType(units, 'velocity mils', "ui") + ")",
            expr_unit: unitType(units, 'velocity mils'),
            expr: "PredictedCorrosionRateConfidenceBandLowerValue",
            color: "#FB594E",
            stackgroup: "one"
        },
        PredictedCorrosionRateConfidenceBandUpperValue: {
            available: true,
            fetch: 1,
            group: 99,
            enabled: false,
            name: "Predicted corrosion rate confidence band upper value",
            unit: "(" + unitType(units, 'velocity mils', "ui") + ")",
            expr_unit: unitType(units, 'velocity mils'),
            expr: "PredictedCorrosionRateConfidenceBandUpperValue",
            color: "#6F0000",
            stackgroup: "two"
        },
        ForecastWallThickness: {
            available: true,
            fetch: 2,
            group: 3,
            enabled: false,
            name: "Forecasted wall thickness",
            unit: "(" + unitType(units, "length", "ui") + ")",
            expr_unit: unitType(units, 'length'),
            color: "#C9EC9A",
        },
        InterpolatedMeasuredWT: {
            available: false,
            fetch: 1,
            group: 1,
            enabled: false,
            name: "Interpolated Measured WT",
            unit: "(" + unitType(units, "length", "ui") + ")",
            expr: "ReplicationMeasuredWallThickness",
            expr_unit: unitType(units, 'length'),
            color: "#0097A9",
            dash: "dash",
            width: "1",
        },

        AlertThreshold: {
            available: true,
            fetch: 1,
            group: 4,
            enabled: false,
            name: "Alert threshold",
            unit: "(" + unitType(units, "velocity mils", "ui") + ")",
            expr_unit: unitType(units, 'velocity mils'),
            expr:"AlertThreshold",
            color: "#B88A00",
            dash: "dash",
            width: "1",
        },
        MissingFeatures: {
            available: true,
            fetch: 1,
            group: 2,
            enabled: false,
            name: "Missing features",
            unit: "(" + unitType(units, "missingFeature", "ui") + ")",
            expr_unit: unitType(units, 'missingFeature'),
            expr: "MissingAvailability",
            color: "#6FB993",
            yaxis: "y2",
        },
    };
};